import { Pipe, PipeTransform } from '@angular/core';
import { Student } from '../models/student';
import { StudentRegistration } from '../models/student-registration';

@Pipe({ name: 'gender' })
export class GenderPipe implements PipeTransform {
  transform(student: Student | StudentRegistration): string {
    switch (Number(student.gender)) {
      case 0:
        return 'M';
      case 1:
        return 'W';
      case 2:
        return 'D';
      default:
        return '?';
    }
  }
}
